import {
  Get_Realtime_PartnerMutation,
  RealtimePartnerType
} from "@saleor/graphql";

export const getRealTimePartnerDataByType = (
  type: RealtimePartnerType,
  dataRealtime: Get_Realtime_PartnerMutation
) => {
  if (type === RealtimePartnerType.SHIP_TO) {
    return dataRealtime?.getSapRealtimePartner?.response?.filter(
      e => e.partnerFunction === "WE"
    );
  }
  if (type === RealtimePartnerType.BILL_TO) {
    return dataRealtime?.getSapRealtimePartner?.response?.filter(
      e => e.partnerFunction === "RE"
    );
  }
  return [];
};
